import React, { useState } from 'react';
import { 
  Button, 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  ListItemText, 
  Typography,
  useTheme
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { languages, changeLanguage, getCurrentLanguage } from '../config/i18n';

const LanguageSwitcher: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const currentLanguage = getCurrentLanguage();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lng: string) => {
    changeLanguage(lng);
    handleClose();
  };

  return (
    <>
      <Button
        color="inherit"
        startIcon={<LanguageIcon />}
        onClick={handleClick}
        sx={{ 
          textTransform: 'none',
          minWidth: 'auto',
          px: 1
        }}
      >
        <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
          {languages[currentLanguage as keyof typeof languages]?.flag} {t('common.language')}
        </Typography>
        <LanguageIcon sx={{ display: { xs: 'block', sm: 'none' } }} />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
      >
        {Object.entries(languages).map(([code, { nativeName, flag }]) => (
          <MenuItem 
            key={code} 
            onClick={() => handleLanguageChange(code)}
            selected={currentLanguage === code}
            sx={{
              '&.Mui-selected': {
                backgroundColor: theme.palette.primary.light,
              },
              '&.Mui-selected:hover': {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              {flag}
            </ListItemIcon>
            <ListItemText>{nativeName}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher; 